/** ITR source → recommended form (static UI; not fetched from backend). */
export const SOURCE_ITR_PRICING_GUIDE = [
  {
    source: 'Salary',
    itr: 'Usually ITR-1',
    docs: 'PAN, Aadhaar, Form 16, bank interest details',
  },
  {
    source: 'Business',
    itr: 'Usually ITR-3',
    docs: 'PAN, Aadhaar, turnover summary, P&L / books, bank statement',
  },
  {
    source: 'Profession',
    itr: 'Usually ITR-3 or ITR-4',
    docs: 'PAN, Aadhaar, receipts summary, expense details, bank statement',
  },
  {
    source: 'House Property',
    itr: 'Usually ITR-1 or ITR-2',
    docs: 'PAN, Aadhaar, rental details, home loan interest certificate',
  },
  {
    source: 'Capital Gains',
    itr: 'Usually ITR-2 or ITR-3',
    docs: 'PAN, Aadhaar, broker/capital gain statement, sale-purchase details',
  },
  {
    source: 'Other Sources',
    itr: 'Usually ITR-1 or ITR-2',
    docs: 'PAN, Aadhaar, interest/dividend/family pension details',
  },
  {
    source: 'Multiple Sources',
    itr: 'Based on your mix (ITR-2/3/4)',
    docs: 'All relevant proofs for each income source',
  },
];
